import { useEffect, useRef, TextareaHTMLAttributes } from 'react';

type AutoResizeTextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onSubmit'> & {
  onSubmit?: () => void;
};

export const AutoResizeTextarea = ({
  onSubmit,
  onKeyDown,
  onInput,
  ...props
}: AutoResizeTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [props.value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey) {
      if (onSubmit) {
        e.preventDefault();
        onSubmit();
      }
    }
    onKeyDown?.(e);
  };

  const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
    e.currentTarget.style.height = 'auto';
    e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`;
    onInput?.(e);
  };

  return (
    <textarea
      ref={textareaRef}
      onKeyDown={handleKeyDown}
      onInput={handleInput}
      rows={1}
      {...props}
    />
  );
};

AutoResizeTextarea.displayName = 'AutoResizeTextarea';
